import { HODLStakingPoolRewarderAddress as t } from "@deorderbook/contracts";
import { initStakingPoolRewarderContract as e } from "./stakingPoolRewarderContract.mjs";
import { signer as n, provider as a } from "./provider.mjs";
const i = () => e(t), l = (o = !1) => {
  const r = i();
  return o ? r.connect(n) : r.connect(a);
};
export {
  i as initHODLPoolRewarderContract,
  l as useHODLPoolRewarderContract
};
//# sourceMappingURL=hodlPoolRewarderContract.mjs.map
